export default {
  comissoes: [],
  comissao: {
    agenda: {},
  },
  conselheiros: [],
  pessoas_fisica: [],
  pagination: {},
};
